/* Mobile-only placement; no app settings, iframe source or click handlers changed. */
(() => {
  'use strict';
  const mobile = window.matchMedia('(max-width: 767px)');
  let dock, looxSlot, googleSlot, loox, looxHome, google, googleObserver;
  let pending = false;
  function schedule() {
    if (!pending) {
      pending = true;
      requestAnimationFrame(() => { pending = false; update(); });
    }
  }
  function createDock() {
    const footer = document.querySelector('.shopify-section-group-footer-group')?.closest('footer') || document.querySelector('footer');
    if (!footer) return false;
    dock = document.createElement('section');
    dock.className = 'aydins-mobile-reviews';
    dock.setAttribute('aria-label', 'Customer reviews and store quality');
    dock.hidden = true;
    dock.innerHTML = '<h2 class="aydins-mobile-reviews__title">Reviews &amp; store trust</h2><div class="aydins-mobile-reviews__loox"></div><div class="aydins-mobile-reviews__google" hidden></div>';
    footer.before(dock);
    looxSlot = dock.querySelector('.aydins-mobile-reviews__loox');
    googleSlot = dock.querySelector('.aydins-mobile-reviews__google');
    resize.observe(dock);
    return true;
  }
  function setPosition(name, value) {
    if (google.style.getPropertyValue(name) !== value) google.style.setProperty(name, value);
  }
  function update() {
    const foundGoogle = document.getElementById('google-merchantwidget-iframe-wrapper');
    if (foundGoogle !== google) {
      googleObserver?.disconnect();
      google = foundGoogle;
      if (google) {
        googleObserver = new MutationObserver(schedule);
        googleObserver.observe(google, {attributes: true, attributeFilter: ['style']});
      }
    }
    const foundLoox = document.getElementById('loox-floating-widget-btn')?.closest('.loox-float-toggler-container') || null;
    if (foundLoox !== loox) {
      looxHome?.remove();
      loox = foundLoox;
      looxHome = null;
    }
    if (!mobile.matches) {
      if (loox && looxHome?.isConnected) looxHome.replaceWith(loox);
      looxHome = null;
      if (dock) dock.hidden = true;
      if (google) {
        google.classList.remove('aydins-review-docked', 'aydins-review-expanded');
        google.style.removeProperty('--aydins-review-top');
        google.style.removeProperty('--aydins-review-left');
      }
      return;
    }
    if (!loox && !google) { if (dock) dock.hidden = true; return; }
    if (!dock && !createDock()) return;
    dock.hidden = false;
    if (loox && loox.parentNode !== looxSlot) {
      looxHome = document.createComment('Aydins: original desktop Loox position');
      loox.before(looxHome);
      looxSlot.append(loox);
    }
    googleSlot.hidden = !google;
    if (google) {
      google.classList.add('aydins-review-docked');
      // The native app grows its wrapper when a customer opens store quality.
      google.classList.toggle('aydins-review-expanded', parseFloat(google.style.height) > 160);
      const rect = googleSlot.getBoundingClientRect();
      const parent = google.offsetParent;
      const relative = parent && parent !== document.body && parent !== document.documentElement;
      const origin = relative ? parent.getBoundingClientRect() : {top: 0, left: 0};
      const scrollY = relative ? parent.scrollTop - parent.clientTop : window.scrollY;
      const scrollX = relative ? parent.scrollLeft - parent.clientLeft : window.scrollX;
      setPosition('--aydins-review-top', `${Math.round(rect.top - origin.top + scrollY + 8)}px`);
      setPosition('--aydins-review-left', `${Math.round(rect.left - origin.left + scrollX + rect.width / 2)}px`);
    }
  }
  const resize = new ResizeObserver(schedule);
  function start() {
    resize.observe(document.body);
    const main = document.getElementById('MainContent');
    if (main) resize.observe(main);
    new MutationObserver(schedule).observe(document.body, {childList: true, subtree: true});
    mobile.addEventListener('change', schedule);
    window.addEventListener('resize', schedule, {passive: true});
    document.addEventListener('shopify:section:load', schedule);
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
